import { render } from "./ClientPaymentStatus.vue?vue&type=template&id=346673db&ts=true"
import script from "./ClientPaymentStatus.vue?vue&type=script&lang=ts"
export * from "./ClientPaymentStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__